import React from 'react';
import PropTypes from "prop-types";
import { StyledBox } from './styled';

const Box = ({ children, as, customStyle }) => {
    return (
        <StyledBox
            as={as}
            customStyle={customStyle}
        >
            {children}
        </StyledBox>
    );
};

Box.propTypes = {
    children: PropTypes.node,
    as: PropTypes.string,
    customStyle: PropTypes.array
};

export default React.memo(Box);
